// export const stylesConfig = {
//   mainLogo: `${process.env.REACT_APP_I18N_PATH}/logo/menu_top_logo.png?ddd2`,
// };
// 取得當前網域
const currentDomain = window.domain_name || window.location.hostname;

// 設定預設路徑
const COMMON_WEB_PATH = process.env.REACT_APP_AWS_PATH || "";

// 根據網域設定不同的logo
let mainLogoPath = `${process.env.REACT_APP_I18N_PATH}/logo/menu_top_logo.png?ddd2`;
let animationLogoPath = `${COMMON_WEB_PATH}/FlyDragon/LOGO_animation.png`;

// 特定網域使用不同的logo
if (currentDomain === "gd88.tw" || currentDomain === "pc.gd88.tw") {
  mainLogoPath = `${process.env.REACT_APP_I18N_PATH}/logo/gd_logo_500.png?ddd2`;
  animationLogoPath = `${process.env.REACT_APP_I18N_PATH}/logo/gd_logo_500.png?ddd2`;
}

export const stylesConfig = {
  mainLogo: mainLogoPath,
  animationLogo: animationLogoPath,
};
